import React from 'react';
import { NavLink } from 'react-router-dom';
import replaceCharacters from '../../components/utilities/helpers';
import { TooltipTableCell } from '../../components/utilities/Table/TooltipTableCell';
import { RequestId } from '../../components/utilities/Table/generalColumns/RequestId';

const requestsListStatus = [
    {
        id: 'en_proceso',
        label: 'EN PROCESO',
        status: '5,10,20,30,40,50,60',
        responsable: null,
        groupCounterGestion: 11,
        columns: [
            RequestId,
            {
                Header: 'Fecha Creación',
                accessor: 'created_at',
            },
            {
                Header: 'Concesionario',
                accessor: 'concesionario.label',
            },
            {
                Header: 'Aliado',
                accessor: 'aliado',
            },
            {
                Header: 'Marca',
                accessor: 'vehiculossolicitud.marca.label',
            },
            {
                Header: 'Línea',
                accessor: 'vehiculossolicitud.linea.label',
            },
            {
                Header: 'Identificación',
                accessor: 'persona.numero_identificacion',
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
                typeId: 'HeaderClient',
            },
            {
                Header: 'Tel Cliente',
                accessor: 'persona_info_contacto.celular',
            },
            {
                Header: () => 'Ejecutivo',
                id: 'ejecutivo',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.name
                        }
                        tooltipText={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.email
                        }
                    />
                ),
            },
            {
                Header: () => 'Estado',
                id: 'estado_solicitud',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={row.original.estado_solicitud.label}
                        tooltipText={replaceCharacters(
                            'data-estate-request',
                            row.original
                        )}
                    />
                ),
            },
        ],
    },
    {
        id: 'desembolsadas_gerente_zona',
        label: 'DESEMBOLSADAS',
        status: '90',
        responsable: null,
        offices: true,
        columns: [
            {
                Header: () => 'Solicitud',
                id: 'id',
                Cell: ({ row }) => {
                    return (
                        <NavLink
                            to={`process/${row.original.persona.numero_identificacion}/${row.original.pk}/${row.original?.persona.pk}`}
                            className="finamiga-color">
                            {' '}
                            <span className="box-state">{row.original.pk}</span>
                        </NavLink>
                    );
                },
            },
            {
                Header: 'Fecha Desembolso',
                accessor: 'gestionsolicitud.fecha_desembolso',
            },
            {
                Header: 'Concesionario',
                accessor: 'concesionario.label',
            },
            {
                Header: 'Aliado',
                accessor: 'aliado',
            },
            {
                Header: 'Marca',
                accessor: 'vehiculossolicitud.marca.label',
            },
            {
                Header: 'Línea',
                accessor: 'vehiculossolicitud.linea.label',
            },
            {
                Header: 'Identificación',
                accessor: 'persona.numero_identificacion',
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
            },
            {
                Header: 'Tel Cliente',
                accessor: 'persona_info_contacto.celular',
            },
            {
                Header: () => 'Ejecutivo',
                id: 'ejecutivo',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.name
                        }
                        tooltipText={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.email
                        }
                    />
                ),
            },
            {
                Header: () => 'Estado',
                id: 'estado_solicitud',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={row.original.estado_solicitud.label}
                        tooltipText={replaceCharacters(
                            'data-estate-request',
                            row.original
                        )}
                    />
                ),
            },
        ],
        registrationLimit: 5, // limit for registration in list credits
    },
];

export default requestsListStatus;
